import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import * as Yup from "yup";
import { store } from "../../redux/storeConfig/store";
import {
  createClass,
  getAllMembers,
  getTrainer,
  getTrainers,
} from "../../redux/actions/api/apiAction";
import {
  checkIfTimesWithenTrainerSchedule,
  getClassDatesObject,
} from "./utils";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { useSelector } from "react-redux";
import { DateHelper } from "../../helper/helpers";
import _ from "lodash";
import { ForceAddModal } from "./forcaAddModel";
import { setForceAddModalOpen } from "../../redux/actions/class/classAction";
import SpinnerComponent from "../spinner/spinner";

const renderStep = (step, values, errors, touched, setFieldValue) => {
  return (
    <FormFirstStep
      errors={errors}
      touched={touched}
      values={values}
      setFieldValue={setFieldValue}
    />
  );
};

function MultiStepForClass({
  handleSubmit,
  waitingList,
  addPrivate,
  edit,
  showTrainer,
  trainer,
  startDate,
  endDate,
  name,
  capacity,
  day,
  to,
  from,
  type,
  tax,
  waitingListRule,
  waitingListCapacity,
  bookingWindowStart,
  bookingWindowEnd,
  bookingStartUnit,
  bookingEndUnit,
  cancelBefore,
  timesArray,
}) {
  const [step, setStep] = useState(1);
  const [canSubmit, setCanSubmit] = useState(false);

  const { forceAddModalOpen } = useSelector((state) => state.class);
  const { loading } = useSelector((state) => state.gym);

  useEffect(() => {
    store.dispatch(
      getAllMembers(
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
    store.dispatch(
      getTrainers(
        1,
        1000,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
  }, []);

  const { trainer: selectedTrainer } = useSelector((state) => state.trainer);

  const submit = async (values) => {
    let {
      bookingWindowEnd,
      bookingWindowStart,
      startDate,
      endDate,
      classDates,
      bookingStartUnit,
      bookingEndUnit,
      cancelBefore,
      cancelationWindowUnit,
      timesArray,
      payRates,
    } = values;

    const { scheduleDays } = selectedTrainer;

    let openForceAddModal;

    let datesObj = {};

    const classDays = classDates.map((date) => {
      let dayString = DateHelper.GetFullDayString(parseInt(date));
      let arr = [];
      for (let i = 0; i < timesArray.length; i++) {
        const element = timesArray[i];
        arr.push({
          start: element.from,
          end: element.to,
        });
      }
      datesObj[dayString] = arr;
      arr = [];
      return dayString;
    });

    openForceAddModal = !checkIfTimesWithenTrainerSchedule(
      classDays,
      scheduleDays,
      datesObj
    );

    if (openForceAddModal) {
      store.dispatch(setForceAddModalOpen(true));
    }

    const datesToSend = [startDate, endDate].map((item) => item.getTime());

    let timeForDates = [];
    let correctDateTimes = values.classDates.map((date) => {
      let dateString = moment(date).format("DD/MM/yyyy");
      for (let index = 0; index < timesArray.length; index++) {
        const element = timesArray[index];
        timeForDates.push({
          from: parseInt(
            moment(dateString + " " + element.from, "DD/MM/yyyyLT").format("x")
          ),
          to: parseInt(
            moment(dateString + " " + element.to, "DD/MM/yyyyLT").format("x")
          ),
        });
      }
    });
    try {
      let datesWithBookings = getClassDatesObject(
        bookingWindowStart,
        bookingWindowEnd,
        timeForDates,
        bookingStartUnit,
        bookingEndUnit,
        cancelBefore,
        cancelationWindowUnit
      );

      let req = _.cloneDeep(values);
      req.classDates = datesWithBookings;
      [("startDate", "endDate")].forEach((item, idx) => {
        req[item] = datesToSend[idx];
      });

      req.startDate = datesToSend[0];
      req.endDate = datesToSend[1];

      req.assignedPackages.forEach((pack) => {
        if (!parseInt(pack.count)) {
          if (!pack?.allowTransfereBookings) {
            pack.count = pack.sessionCount;
          } else {
            pack.count = 0;
          }
        }
      });
      req.payrateId =
        req?.payRates && req?.payRates.length && req?.payRates[0]?.id;
      if (!openForceAddModal) store.dispatch(createClass(req));
    } catch (e) {
      toastr.error(e.message);
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = Yup.object().shape({
    trainer: Yup.number(),
    capacity: Yup.number()
      .positive("must be > 0")
      .required("Capacity is required"),
    waitingList: Yup.boolean(),
    repeatDays: Yup.array()
      .min(1, "Select at least one day")
      .required("Please select days of class"),
    endDate: Yup.date().required("Class end date is required"),
    startDate: Yup.date().required("Class start date is required"),
    timesArray: Yup.array()
      .min(1, "Select at least one time range")
      .of(
        Yup.object().shape({
          from: Yup.string()
            .required("Please select start time")
            .test(
              "is-before-end",
              "Start time must be before end time",
              function(value) {
                const { to } = this.parent; // Access the 'to' field
                return moment(value, "HH:mm").isBefore(moment(to, "HH:mm"));
              }
            ),
          to: Yup.string()
            .required("Please select end time")
            .test(
              "is-after-start",
              "End time must be after start time",
              function(value) {
                const { from } = this.parent; // Access the 'from' field
                return moment(value, "HH:mm").isAfter(moment(from, "HH:mm"));
              }
            ),
        })
      )
      .test(
        "is-time-range-conflict",
        "Time ranges should not overlap",
        function(value) {
          const timeRanges = value.map((range) => ({
            from: moment(range.from, "HH:mm"),
            to: moment(range.to, "HH:mm"),
          }));

          for (let i = 0; i < timeRanges.length; i++) {
            for (let j = i + 1; j < timeRanges.length; j++) {
              if (
                timeRanges[i].from.isBetween(
                  timeRanges[j].from,
                  timeRanges[j].to,
                  null,
                  "[)"
                ) ||
                timeRanges[i].to.isBetween(
                  timeRanges[j].from,
                  timeRanges[j].to,
                  null,
                  "(]"
                )
              ) {
                return false; // Time ranges overlap
              }
            }
          }

          return true; // No conflicts
        }
      ),
    name: Yup.string()
      .max(300, "cannot be > 300 characters")
      .required("Class name is required"),
    type: Yup.string().required("Please select class type"),
    freeTrial: Yup.boolean(),
    autoCreateSinglePackage: Yup.boolean(),
    image: Yup.string(),
    cancelBefore: Yup.string().required("Cancelation time is required"),
    // bookingWindowStart: Yup.string().required("Booking opening is required"),
    // bookingWindowEnd: Yup.string().required("Booking closing is required"),
    waitingListRule: Yup.string().when("waitingList", {
      is: true,
      then: Yup.string().required("Wait list capacity is required"),
    }),
    waitingListCapacity: Yup.number().when("waitingList", {
      is: true,
      then: Yup.number()
        .positive("Capacity must be > 0")
        .required("Wait list capacity is required"),
    }),
    assignedPackages: Yup.array().when("autoCreateSinglePackage", {
      is: false,
      then: Yup.array().required(
        "Please assign the class for at least one package or auto create single session package"
      ),
    }),
  });

  let autoCreateSinglePackage = false;

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          edit,
          payRates: null,
          waitingList: false,
          freeTrial: false,
          trainer: trainer,
          showTrainer,
          startDate,
          endDate,
          name,
          capacity,
          day,
          to,
          from,
          type,
          tax,
          waitingListRule,
          waitingListCapacity,
          autoCreateSinglePackage,
          allowCancelation: false,
          allowUnpaidBooking: false,
          noShowDeduction: false,
          classDates: [],
          bookingWindowEnd,
          bookingWindowStart,
          bookingStartUnit: "d",
          bookingEndUnit: "d",
          cancelationWindowUnit: "h",
          cancelBefore,
          timesArray: [],
          gender: "",
          disableOnlineBooking: false,
          description: "",
          court: null,
          isPublished:true
        }}
        onSubmit={submit}
        validationSchema={formSchema1}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <>
            <Form>
              {renderStep(step, values, errors, touched, setFieldValue)}
              <StepButton
                step={step}
                previous={previous}
                edit={edit}
                addPrivate={addPrivate}
              />
            </Form>
            <ForceAddModal values={values} />
          </>
        )}
      </Formik>
    </>
  );
}
MultiStepForClass.defaultProps = {
  members: [],
  startDate: new Date(),
  endDate: new Date(),
  handleSubmit: (values) => {
    //console.log(values, "values here");
  },
  addPrivate: () => {},
  edit: false,
  trainer: "",
  showTrainer: true,
  waitingList: false,
  waitingListRule: "auto",
  freeTrial: false,
  autoCreateSinglePackage: true,
  isPublished:true
};

export default MultiStepForClass;
